import React from 'react'
import { TeamState } from 'state/teams'
import { useCheckTeamPermission } from 'hooks/permissions'

type TeamRestrictedProps = {
    selectedTeam: TeamState
    isAssignRoles?: boolean
}

const TeamRestricted: React.FC<TeamRestrictedProps> = ({ selectedTeam, children, isAssignRoles = false }) => {
    const isShow = useCheckTeamPermission(selectedTeam, isAssignRoles)

    if (isShow) {
        return <>{children}</>
    }

    return null
}

export default TeamRestricted
